import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import AlbumDetail from './pages/AlbumDetail';
import SongDetail from './pages/SongDetail';
import Moodboards from './pages/Moodboards';
import MoodboardDetail from './pages/MoodboardDetail';
import UserSettings from './pages/UserSettings';
import Login from './components/auth/Login';
import Navbar from './components/Navbar';
import { AuthProvider, useAuth } from './components/auth/AuthProvider';
import { AudioProvider } from './contexts/AudioContext';
import GlobalAudioPlayer from './components/GlobalAudioPlayer';
import PasswordProtection from './components/auth/PasswordProtection';
import ProtectedRoute from './components/auth/ProtectedRoute';

// We now use the imported ProtectedRoute component that checks for password authentication

function AppRoutes() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/password" replace />} />
          <Route path="/password" element={<PasswordProtection />} />
          
          {/* Protected routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Navbar />
              <div className="container mx-auto px-4 py-8">
                <Dashboard />
              </div>
            </ProtectedRoute>
          } />
          
          <Route path="/albums/:albumId" element={
            <ProtectedRoute>
              <Navbar />
              <div className="container mx-auto px-4 py-8">
                <AlbumDetail />
              </div>
            </ProtectedRoute>
          } />
          
          <Route path="/songs/:songId" element={
            <ProtectedRoute>
              <Navbar />
              <div className="container mx-auto px-4 py-8">
                <SongDetail />
              </div>
            </ProtectedRoute>
          } />
          
          <Route path="/moodboards" element={
            <ProtectedRoute>
              <Navbar />
              <div className="container mx-auto px-4 py-8">
                <Moodboards />
              </div>
            </ProtectedRoute>
          } />
          
          <Route path="/moodboards/:moodboardId" element={
            <ProtectedRoute>
              <Navbar />
              <div className="container mx-auto px-4 py-8">
                <MoodboardDetail />
              </div>
            </ProtectedRoute>
          } />
          
          <Route path="/settings" element={
            <ProtectedRoute>
              <Navbar />
              <UserSettings />
            </ProtectedRoute>
          } />
        </Routes>
      </div>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <AudioProvider>
        <AppRoutes />
        <GlobalAudioPlayer />
      </AudioProvider>
    </AuthProvider>
  );
}

export default App;
